import { render, staticRenderFns } from "./MovementUnloadList.vue?vue&type=template&id=1af02001"
import script from "./MovementUnloadList.vue?vue&type=script&lang=js"
export * from "./MovementUnloadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports